/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { globalBreak } from '@/styles/break';
import { resBreak } from '@/utils/resBreak';
import { StackProps, SxProps } from '@mui/material';

export const productDetailsAddToCartStack = (standalone?: boolean): StackProps => ({
	direction: resBreak({ mobile: 'column', tablet: 'row' }),
	spacing: 1,
	justifyContent: resBreak({ mobile: 'center', tablet: standalone ? 'flex-end' : 'flex-start' }),
	width:'100%'
});

export const addtocartbuttonSX:SxProps ={
	backgroundColor:'#53aa28',
	color:'black',
	width:'100%',
	fontWeight : 'bold',
	fontSize : '20px',
	'&:hover':{
        backgroundColor:'#3b7b1b',
    },
	'& span':{fontWeight:400, fontFamily:'mikado-medium', 
		fontSize: globalBreak({mobile:'16px',desktop:'18px'})
	},
	columnGap:2,
	alignItems:'center'
}

export const BrandAndSeriesLinksSX:SxProps ={
		textDecoration:'none',
		fontWeight:400,
		'&:hover':{
			textDecoration:'none'
		}
}

export const basketIconPDPSX:SxProps ={
	fontSize:20,
	color: '#000'
}